var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8492 15.6562L20.053 16.2299L14.3408 3.9264C14.0785 3.3609 13.4326 3.00399 12.7344 3.03821C12.0363 3.07244 11.4417 3.49127 11.2532 4.07878L8.98412 11.1762L5.07607 2.75953L6.10465 2.68783C6.48547 2.66094 6.64415 2.26166 6.33706 2.10113L2.41594 0.0477013C2.18913 -0.0712673 1.86525 0.043627 1.79711 0.266897L0.620125 4.12604C0.52772 4.42754 0.959873 4.61822 1.25482 4.40554L2.05099 3.83188L7.7586 16.1248C8.02088 16.6903 8.66677 17.0472 9.36494 17.013C10.0631 16.9787 10.6577 16.5599 10.8462 15.9724L13.1153 8.87501L17.028 17.3022L15.9994 17.3739C15.6186 17.4008 15.4599 17.8001 15.767 17.9606L19.6909 20.0149C19.9177 20.1338 20.2416 20.0189 20.3097 19.7957L21.4867 15.9365C21.5791 15.635 21.147 15.4444 20.852 15.657L20.8492 15.6562Z",
    fill: "url(#paint0_linear_7880_7191)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7880_7191",
    x1: 11.0534,
    y1: 20.0242,
    x2: 11.0534,
    y2: -4.84712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#018EC5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.97dd20cc10c7d1e44e8ecb8c7918f141.svg";
export { ForwardRef as ReactComponent };